export default __webpack_public_path__ + "static/media/StockSnap_compressed.171d47d5.png";